import React from 'react';
import { shape, arrayOf, string } from 'prop-types';

import Box from '../atoms/Box';
import Text from '../atoms/Text';

import ExpandablePanel from '../molecules/ExpandablePanel';
import SanitizedHTML from '../elements/SanitizedHTML';

import { externalRoutes } from '../../routes';

const { schema } = externalRoutes;

const FaqQuestions = ({ questionsByCategory = [] }) => {
  return (
    <Box itemScope itemType={schema.faq}>
      {questionsByCategory.map(({ category, questions = [] }, index) => (
        <div key={index}>
          <Text tag="h2" styleName="wH3" mt={10} mb={5} key={category}>
            {category}
          </Text>
          {questions.map(({ q, a }, index) => {
            const schemaTitle = {
              'data-cy': `question-${q.substring(0, 25).toLowerCase().replace(/\s/g, '-')}`,
              itemScope: true,
              itemProp: 'mainEntity',
              itemType: schema.question
            };
            const schemaChildren = { itemScope: true, itemProp: 'acceptedAnswer', itemType: schema.answer };

            return (
              q !== '$' && (
                <ExpandablePanel
                  key={index}
                  title={
                    <Text tag="h3" styleName="wH4" itemProp="name">
                      {q}
                    </Text>
                  }
                  schemaTitle={schemaTitle}
                  schemaChildren={schemaChildren}>
                  <Text tag="span" itemProp="text" styleName="wPNormal">
                    <SanitizedHTML tagElement="span" content={a} />
                  </Text>
                </ExpandablePanel>
              )
            );
          })}
        </div>
      ))}
    </Box>
  );
};

FaqQuestions.propTypes = {
  questionsByCategory: arrayOf(
    shape({
      category: string,
      questions: arrayOf(
        shape({
          a: string,
          q: string
        })
      )
    })
  )
};

export default FaqQuestions;
